import './IntroductionSection.less';
import React from 'react';
import DraftView from "../../../components/draft-view/DraftView";
import __ from "../../../i18n";


export default function IntroductionSection({introduction}) {

    return <div className="introduction-section">
        <h2 className="title">{__('Introduction')}</h2>
        <DraftView contentState={introduction}/>
    </div>;
}
